export const fieldLabelFor = (field, t)=>{
    switch(field){
        case 'agreementName':
            return t.agreementNameLabel();
        case 'clientName':
            return t.clientNameLabel();
        case 'contactName':
            return t.recipientNameLabel();
    }
};
